export default function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  disabled = false,
  className = '',
  ...props
}) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      className={`w-full px-4 py-2 bg-white dark:bg-background-gray border border-border-light dark:border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-brand-primary focus:border-transparent text-text-primary-light dark:text-text-primary placeholder:text-text-muted-light dark:placeholder:text-text-muted ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
      {...props}
    />
  );
}
